import { FETCH_AUTO_SUMMARY, FETCH_AUTO_SUMMARY_SUCCESS, FETCH_AUTO_SUMMARY_ERROR } from '../actions/summary';

export default function(state = {}, action) {
  switch (action.type) {
  case FETCH_AUTO_SUMMARY:
    return { ...state, isLoading: true };
  case FETCH_AUTO_SUMMARY_SUCCESS:
    return Object.assign({}, ...state, {
      summary: action.payload.data,
      isLoading: false,
    });
  case FETCH_AUTO_SUMMARY_ERROR:
    return { ...state, error: action.error, isLoading: false };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_auto_summary.js